<div class="bg-slate-900 border border-slate-800 p-6 rounded-xl relative overflow-hidden flex flex-col h-full">
    <!-- Header -->
    <div class="flex justify-between items-start mb-6 z-10">
        <div>
            <h3 class="text-white font-bold text-lg flex items-center gap-2">
                <i class="fa-solid fa-stethoscope text-emerald-500"></i> System Health
            </h3>
            <p class="text-xs text-slate-400 mt-1">
                Last check: {{ lastRun() ? (lastRun() | date:'HH:mm:ss') : 'Never' }}
            </p>
        </div>
        <div class="text-right">
            <div class="text-3xl font-black" [class]="getHealthColor()">{{ overallHealth() }}%</div>
            <p class="text-[10px] uppercase tracking-wider text-slate-500">Operational Score</p>
        </div>
    </div>

    <!-- Test List -->
    <div class="space-y-3 flex-grow z-10">
        @for(test of tests(); track test.id) {
            <div class="flex items-center justify-between p-3 rounded-lg bg-slate-950/50 border border-slate-800 hover:border-slate-700 transition-colors">
                <div class="flex items-center gap-3">
                    <div class="w-8 h-8 rounded-full flex items-center justify-center bg-slate-900"
                         [class.text-slate-500]="test.status === 'pending'"
                         [class.text-blue-400]="test.status === 'running'"
                         [class.animate-pulse]="test.status === 'running'"
                         [class.text-emerald-400]="test.status === 'success'"
                         [class.text-yellow-400]="test.status === 'warning'"
                         [class.text-red-500]="test.status === 'failed'">
                        <i class="fa-solid" [class]="test.status === 'running' ? 'fa-circle-notch fa-spin' : test.icon"></i>
                    </div>
                    <div>
                        <div class="text-sm font-medium text-slate-200">{{ test.name }}</div>
                        <div class="text-xs" 
                             [class.text-slate-500]="test.status === 'pending'"
                             [class.text-blue-400]="test.status === 'running'"
                             [class.text-emerald-500]="test.status === 'success'"
                             [class.text-yellow-500]="test.status === 'warning'"
                             [class.text-red-500]="test.status === 'failed'">
                            {{ test.message }}
                        </div>
                    </div>
                </div>
                
                @if(test.latency !== undefined) {
                    <div class="text-xs font-mono px-2 py-1 rounded bg-slate-900 text-slate-400 border border-slate-800">
                        {{ test.latency | number:'1.0-0' }}ms
                    </div>
                }
            </div>
        }
    </div>

    <!-- Action Button -->
    <div class="mt-6 z-10">
        <button (click)="runTests()" [disabled]="isRunning()" 
                class="w-full py-3 rounded-lg font-bold text-sm transition-all flex items-center justify-center gap-2 shadow-lg group relative overflow-hidden"
                [class.bg-slate-800]="isRunning()"
                [class.text-slate-500]="isRunning()"
                [class.cursor-wait]="isRunning()"
                [class.bg-emerald-600]="!isRunning()"
                [class.hover:bg-emerald-500]="!isRunning()"
                [class.text-white]="!isRunning()">
            
            <span class="relative z-10 flex items-center gap-2">
                @if(isRunning()) {
                    <i class="fa-solid fa-microchip animate-pulse"></i> Running Diagnostics...
                } @else {
                    <i class="fa-solid fa-play"></i> Run Smoke Test
                }
            </span>
            
            <!-- Shine effect -->
            @if(!isRunning()) {
                <div class="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent z-0"></div>
            }
        </button>
    </div>

    <!-- Background Decor -->
    <div class="absolute -bottom-10 -left-10 w-40 h-40 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none"></div>
    <div class="absolute -top-10 -right-10 w-40 h-40 bg-blue-500/10 rounded-full blur-3xl pointer-events-none"></div>
</div>
